<form [formGroup]="formGroup">
  <country-wrapper>
    <ng-template country="NZ">
      <lds-numeric-input
        formControlName="businessNumber"
        name="businessNumber"
        label="NZBN"
        placeholder="XXX-XXX-XXXXXXX"
        [allowLeadingZeros]="true"
        [isRequired]="isRequired"
        [showHighlight]="showHighlight"
        [minlength]="13"
        [maxlength]="13"
        [validations]="{
          nzbn: 'Must be a valid NZ business number'
        }">
      </lds-numeric-input>
    </ng-template>
    <ng-template countryDefault>
      <lds-numeric-input
        formControlName="businessNumber"
        name="businessNumber"
        label="ABN"
        placeholder="XX-XXX-XXX-XXX"
        [isRequired]="isRequired"
        [showHighlight]="showHighlight"
        [minlength]="11"
        [maxlength]="14"
        [validations]="{
          abn: 'Must be a valid ABN'
        }">
      </lds-numeric-input>
    </ng-template>
  </country-wrapper>
</form>
